// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3mUgt","noInteraction":"EventWrapper_noInteraction__FEltp"};